package com.downdogapp.client.controllers.menu

import com.downdogapp.client.Strings
import com.downdogapp.client.ViewController
import com.downdogapp.client.api.UpdatePasswordRequest
import com.downdogapp.client.singleton.App
import com.downdogapp.client.singleton.Network
import com.downdogapp.client.views.menu.createUpdatePasswordView

class UpdatePasswordViewController(val unlinkMessage: String? = null,
                                   private val onPasswordChanged: (() -> Unit)? = null) : ViewController() {

  override val view = createUpdatePasswordView(this)

  val buttonText get() = if (unlinkMessage != null) Strings.SAVE_AND_UNLINK else Strings.SAVE

  fun onSubmitClicked() {
    val password = view.password
    val confirmPassword = view.confirmPassword
    when {
      password.isEmpty() -> onBackClicked()
      password.length < 4 -> App.alert(message = Strings.PASSWORD_LENGTH_MESSAGE)
      password != confirmPassword -> App.alert(message = Strings.PASSWORDS_MUST_MATCH)
      else -> {
        view.spinnerShowing = true
        Network.post(UpdatePasswordRequest(password)) { json ->
          if (json == null) {
            App.alertNoInternet {
              view.spinnerShowing = false
            }
          } else {
            App.fetchManifest {
              view.spinnerShowing = false
            }
            onBackClicked()
            onPasswordChanged?.invoke()
          }
        }
      }
    }
  }

  override fun onBackClicked() {
    App.closeKeyboard()
    super.onBackClicked()
  }
}
